import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import moment from "moment";
import { Modal, Button } from "react-bootstrap";

const initialFieldValues = {
  attendanceId: "00000000-0000-0000-0000-000000000000",
  staffId: "00000000-0000-0000-0000-000000000000",
  attendanceDate: new Date(),
  checkIn: "",
  checkOut: "",
  totalWorkingHours: "",
  totalOverTime: "",
  status: "",
};

export default function CreateAttendance({
  showModal,
  handleCloseModal,
  recordForEdit,
  setRecordForEdit,
  recordToDelete,
  onDeleteSuccess,
}) {
  const [values, setValues] = useState(initialFieldValues);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [staff, setStaff] = useState([]);
  const userId = localStorage.getItem("userId");

  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };

  useEffect(() => {
    if (recordForEdit !== null) {
      setValues({
        ...recordForEdit,
        attendanceDate: moment(recordForEdit.attendanceDate).format(
          "YYYY-MM-DD"
        ),
        checkIn: recordForEdit.checkIn
          ? moment(recordForEdit.checkIn).format("HH:mm")
          : "",
        checkOut: recordForEdit.checkOut
          ? moment(recordForEdit.checkOut).format("HH:mm")
          : "",
      });
    }
  }, [recordForEdit]);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };

  const validate = () => {
    let temp = {};
    temp.staffId = values.staffId !== "00000000-0000-0000-0000-000000000000";
    temp.attendanceDate = values.attendanceDate === "" ? false : true;
    temp.checkIn = values.checkIn === "" ? false : true;
    temp.checkOut = values.checkOut === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("attendanceId", values.attendanceId);
      formData.append("staffId", values.staffId);
      formData.append(
        "attendanceDate",
        moment(values.attendanceDate).format("YYYY-MM-DD")
      );
      formData.append("checkIn", values.checkIn);
      formData.append("checkOut", values.checkOut);
      formData.append("status", values.status);
      addOrEdit(formData);
    }
  };

  const applicationAPI = () => {
    return {
      create: (newrecord) =>
        axios.post(config.APIACTIVATEURL + config.CREATEATTENDANCE, newrecord, {
          ...headerconfig,
        }),
      update: (updateRecord) =>
        axios.put(
          config.APIACTIVATEURL + config.UPDATEDATTENDANCE,
          updateRecord,
          {
            ...headerconfig,
          }
        ),
    };
  };

  const addOrEdit = (formData) => {
    if (
      formData.get("attendanceId") === "00000000-0000-0000-0000-000000000000"
    ) {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            setBtnSubmit(true);
            resetForm();
            handleCloseModal();
            onDeleteSuccess(); // Refresh the parent component
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            setBtnSubmit(true);
            resetForm();
            handleCloseModal();
            onDeleteSuccess(); // Refresh the parent component
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };

  const onDelete = (id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETEATTENDANCE + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            resetForm();
            handleCloseModal();
            onDeleteSuccess(); // Refresh the parent component
          } else {
            handleError(response.data.data);
          }
        })
        .catch((error) => {
          handleError("Error deleting attendance");
        });
    }
  };
  const GetStaff = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETALLSTAFFS + "?userId=" + userId, {
        ...headerconfig,
      })
      .then((response) => {
        setStaff(response.data.data);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    GetStaff();
  }, []);
  useEffect(() => {
    if (recordToDelete) {
      onDelete(recordToDelete);
    }
  }, [recordToDelete]);

  return (
    <Modal show={showModal} onHide={handleCloseModal} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {values.attendanceId === "00000000-0000-0000-0000-000000000000"
            ? "Create Attendance"
            : "Edit Attendance"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <form onSubmit={handleSubmit} autoComplete="off" noValidate>
          <div className="mb-3">
            <label htmlFor="staffId" className="form-label">
              Staff
            </label>
            <select
              type="text"
              value={values.staffId}
              name="staffId"
              onChange={handleInputChange}
              className={"form-select" + applyErrorClass("staffId")}
            >
              <option value="00000000-0000-0000-0000-000000000000">
                Please select
              </option>
              {staff.length > 0 &&
                staff.map((c) => (
                  <option key={c.staffId} value={c.staffId}>
                    {c.staffName}
                  </option>
                ))}
            </select>
            {errors.staffId === false ? (
              <div className="validationerror">Please Select Staff</div>
            ) : null}
          </div>
          <div className="mb-3">
            <label htmlFor="attendancedate" className="form-label">
              Attendance Date
            </label>
            <div className="input-group">
              <input
                type="date"
                className={"form-control" + applyErrorClass("attendanceDate")}
                name="attendanceDate"
                value={values.attendanceDate}
                max={moment().format("YYYY-MM-DD")}
                onChange={handleInputChange}
              />
              {errors.attendanceDate === false ? (
                <div className="validationerror">Please Select Date</div>
              ) : null}
            </div>
          </div>
          <div className="mb-3">
            <label>CheckIn</label>
            <input
              name="checkIn"
              type="time"
              value={values.checkIn}
              onChange={handleInputChange}
              className={"form-control" + applyErrorClass("checkIn")}
            />
            {errors.checkIn === false ? (
              <div className="validationerror">Please Select</div>
            ) : null}
          </div>
          <div className="mb-3">
            <label>CheckOut</label>
            <input
              name="checkOut"
              type="time"
              value={values.checkOut}
              onChange={handleInputChange}
              className={"form-control" + applyErrorClass("checkOut")}
            />
            {errors.checkOut === false ? (
              <div className="validationerror">Please Select</div>
            ) : null}
          </div>
        </form>
      </Modal.Body>
      <Modal.Footer>
        {btnSubmit ? (
          <Button variant="primary" onClick={handleSubmit}>
            {values.attendanceId === "00000000-0000-0000-0000-000000000000"
              ? "Submit"
              : "Update"}
          </Button>
        ) : (
          <Button variant="primary" disabled>
            Please wait...
          </Button>
        )}
        <Button variant="danger" onClick={handleCloseModal}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
